// extracted by mini-css-extract-plugin
export default {"aiFacial":"Jh96IgPS9P+oz1dUhtgiug==","banner":"_7likq7z2Ve1u5UyVwLhMlw=="};